export const ApiDef_PushSubscription = {
    _v1: {}
};
//# sourceMappingURL=api-def.js.map